import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  ManageUsersScreenComponent
} from './screen/manage-users-screen.component';
import {
  ManageUsersFilterComponent
} from './components/manage-users-filter/manage-users-filter.component';
import {
  ManageUsersTableComponent
} from './components/manage-users-table/manage-users-table.component';
import {MatExpansionModule} from "@angular/material/expansion";
import {SharedModule} from "../../shared/shared.module";
import {StoreModule} from "@ngrx/store";
import {EffectsModule} from "@ngrx/effects";
import {ManageUsersEffects} from "./core/manage-users.effects";
import {reducer} from "./core/manage-users.reducer";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatTableModule} from "@angular/material/table";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {MatSortModule} from "@angular/material/sort";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import { ChangeUserStatusComponent } from './components/change-user-status/change-user-status.component';
import { ChangeParticipantsGroupComponent } from './components/change-participants-group/change-participants-group.component';


@NgModule({
  declarations: [
    ManageUsersScreenComponent,
    ManageUsersFilterComponent,
    ManageUsersTableComponent,
    ChangeUserStatusComponent,
    ChangeParticipantsGroupComponent,
  ],
  imports: [
    CommonModule,
    MatExpansionModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.manage-users', reducer),
    EffectsModule.forFeature(
      [ManageUsersEffects]
    ),
    MatProgressSpinnerModule,
    MatTableModule,
    InfiniteScrollModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
  ]
})
export class ManageUsersModule {
}
